import { withInstall } from '@zoryn/utils'
import Tree from './src/tree.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZTree: SFCWithInstall<typeof Tree> = withInstall(Tree)

export default ZTree

export * from './src/tree.type'
export * from './src/instance'
export * from './src/tokens'
export * from './src/tree'
